import { render } from "./physiotherapy_diagnosis.vue?vue&type=template&id=6be34462&scoped=true"
import script from "./physiotherapy_diagnosis.vue?vue&type=script&lang=js"
export * from "./physiotherapy_diagnosis.vue?vue&type=script&lang=js"

import "./physiotherapy_diagnosis.vue?vue&type=style&index=0&id=6be34462&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be34462"]])

export default __exports__